// index.tsx
import React from "react";
import {
  StyledFlightCardSkeleton,
  StyledFlightCardSkeletonLeft,
  StyledFlightCardSkeletonLeftItem,
  StyledFlightCardSkeletonRight,
  StyledPaginationContainerCards,
} from "./styles";
import Skeleton from "Components/atoms/Skeleton";
import { FlightCardSkeletonProps } from "./types";

/**
 * Componente FlightCardSkeleton
 *
 * Representa um esqueleto de carregamento para o card de voo em dispositivos móveis.
 */
export const FlightCardSkeleton: React.FC<FlightCardSkeletonProps> = ({
  isMobile,
}) => {
  return (
    <>
      <StyledPaginationContainerCards isMobile={isMobile}>
        {Array.from({ length: 5 }).map((_, index) => (
          <StyledFlightCardSkeleton key={index}>
            <StyledFlightCardSkeletonLeft isMobile={isMobile}>
              {Array.from({ length: 2 }).map((_, subIndex) => (
                <StyledFlightCardSkeletonLeftItem key={subIndex}>
                  <Skeleton
                    width={20}
                    height={isMobile ? 20 : 25}
                    borderRadius={100}
                    marginLeft={10}
                  />
                  <Skeleton
                    width={isMobile ? 30 : 10}
                    height={isMobile ? 20 : 25}
                    borderRadius={100}
                    marginLeft={isMobile ? 20 : 30}
                  />
                  <Skeleton
                    width={isMobile ? 20 : 10}
                    height={isMobile ? 25 : 40}
                    borderRadius={10}
                    marginLeft={isMobile ? 20 : 40}
                  />
                  <Skeleton
                    width={20}
                    height={isMobile ? 30 : 35}
                    borderRadius={isMobile ? 10 : 100}
                    marginLeft={10}
                  />
                  <Skeleton
                    width={isMobile ? 20 : 10}
                    height={isMobile ? 25 : 40}
                    borderRadius={10}
                    marginLeft={10}
                  />
                </StyledFlightCardSkeletonLeftItem>
              ))}
            </StyledFlightCardSkeletonLeft>

            <StyledFlightCardSkeletonRight isMobile={isMobile}>
              <Skeleton
                width={90}
                height={90}
                borderRadius={10}
                marginLeft={0}
              />
            </StyledFlightCardSkeletonRight>
          </StyledFlightCardSkeleton>
        ))}
      </StyledPaginationContainerCards>
    </>
  );
};

export default FlightCardSkeleton;
